<template>
    <div class="query">
        <van-cell-group>
<!--            <van-field v-model="handName" clearable label="姓名:" placeholder="请输入姓名"/>-->
            <van-field v-model="handlingId" clearable label="身份证号:" placeholder="请输入身份证号"/>
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
            <p style="color: #f80000;text-align: center">本服务只能查询除武汉市以外地市、州的居住证办理进度</p>
        </div>
        <div class="boxList" v-if="listShow">
            <div class="boxList-item">
                <span>姓名:</span>
                <span>{{dataList.xm}}</span>
            </div>
            <div class="boxList-item">
                <span>身份号码:</span>
                <span>{{dataList.gmsfhm}}</span>
            </div>
            <div class="boxList-item">
                <span>受理时间:</span>
                <span>{{dataList.slsj}}</span>
            </div>
            <div class="boxList-item">
                <span>办理进度:</span>
                <span>{{dataList.jzzbl}}</span>
            </div>
        </div>

    </div>
</template>

<script>
    /**
     * Description: 身份证办理进度查询
     * Author: Wangyan
     * Date: 2019-03-25
     * Time: 16:41
     */
    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'
    import {memberApi} from "../../api/member";
    import Vue2Verify from "@/views/signUp/verify/verify";

    export default {
        name: "Funeral",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                handName: '',//姓名
                handlingId: '', // 身份证号
                uuid:'',//用户标识
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                listShow: false,
                dataList: {
                    xm:"",
                    slsj:"",
                    gmsfhm:"",
                    jzzbl:""
                },
            }
        },
        mounted(){
            this.logger.visit('117','0')
            this.initUser()
        },
        methods: {

            /**
             * 初始化用户
             */
            // 用户信息非必需
            async initUser() {
                let _self = this;
                let userInfo = {};
                try {
                    const res = await _self.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
                    console.log("用户信息")
                    console.log(res)
                    if (res.data.succ) {
                        userInfo = res.data.data
                        this.handlingId=userInfo.idNum
                        this.uuid = userInfo.trpId
                    } else {
                        Toast.fail('网络异常，请检查网络')
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(e)
                }
                return userInfo;
            },
            async success(val) {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '查询中...'
                })
                try {
                    const data = {
                        name: "",
                        idNum: this.handlingId,
                        uuid: this.uuid,
                        genGuid: val.captchaVerification,
                        validCode: val.captchaVerification,
                    }
                    const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.jzz}`, data)
                    this.show = false
                    Toast.clear()
                    if (res.data.succ && res.data.code === 200) {
                        this.dataList = res.data.data;
                        console.log(this.dataList.gmsfhm)
                        if(this.dataList.gmsfhm =="" || this.dataList.gmsfhm == undefined || this.dataList.gmsfhm == null){
                            Toast.fail('未查询到相关数据')
                        }else{
                            this.listShow = true
                        }
                    }
                } catch (error) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                }
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 点击查询
             */
            async submit() {
                this.listShow = false
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                }  else{
                    this.show = true
                }
            },

            /**
             * 点击查询
             */
            // async query() {
            //
            //     if (!this.handName) {
            //         Toast('请输入姓名')
            //     } else if (!this.handlingId) {
            //         Toast('请输入身份证号')
            //     } else if(!idCardRegex(this.handlingId)) {
            //         Toast('请输入正确的身份证号')
            //     } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
            //         Toast('请输入验证码')
            //     } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
            //         Toast('请输入正确的验证码')
            //     } else {
            //         Toast.loading({
            //             duration: 0,       // 持续展示 toast
            //             forbidClick: true, // 禁用背景点击
            //             loadingType: 'spinner',
            //             message: '查询中...'
            //         })
            //         if(this.handName == '刘立万' && this.handlingId == '429006199603027698'){
            //             this.listShow = true
            //         }else{
            //             this.listShow = false
            //             Toast.fail('未查询到相关数据')
            //         }
            //
            //         // try {
            //         //     const data = {
            //         //         idNum: this.handlingId,
            //         //         genGuid: this.receiveVerificationCode.verificationCodeGuid,
            //         //         validCode: this.receiveVerificationCode.verificationCode
            //         //     }
            //         //     const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.identity}`, data)
            //         //     Toast.clear()
            //         //     if (res.data.succ) {
            //         //         let data = res.data.data;
            //         //         if (data.length > 0) {
            //         //             this.listShow = true
            //         //             this.dataList = Object.assign([], data)
            //         //         } else {
            //         //             Toast.fail('未查询到相关数据')
            //         //             this.$refs.childFunction.interactionVerificationCode()
            //         //         }
            //         //     } else {
            //         //         Toast.fail(res.data.succ)
            //         //         this.$refs.childFunction.interactionVerificationCode()
            //         //     }
            //         // } catch (error) {
            //         //     Toast.fail('服务器运行失败，请稍后再试。')
            //         //     console.log(error)
            //         // }
            //     }
            // },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .boxList {
        margin-bottom: 0.3rem;
    }
    .boxList-item {
        margin: 0 auto;
        width:90%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
    }

    .boxList-item span {
        font-size: 0.35rem;
        line-height: 1.2rem;
        color: #323233;
    }
    .boxList-item span:first-child {
        font-size: 0.35rem;
        width: 2rem;
        line-height: 1.2rem;
        color: #323233;
    }

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
